import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Template, SelectBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import DropDownButton, { Item as ItemDrop } from 'devextreme-react/drop-down-button';
import { LoadPanel } from 'devextreme-react/load-panel';
import { Switch } from 'devextreme-react/switch';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import themes from 'devextreme/ui/themes';
import { useHistory } from 'react-router-dom';
import { locale, formatMessage } from 'devextreme/localization';
import * as dayjs from 'dayjs';
import { Popup } from 'devextreme-react/popup';
import { CheckBox } from 'devextreme-react/check-box';
import ScrollView from 'devextreme-react/scroll-view';
import { compare, getLocale, themeDark } from '../../utils/functions';
import style from './header.module.scss';
import PopupErrorMVP from '../PopupErrorMVP';

const localizations = ['ru', 'en'];

const Header = ({
  authReducer: { urlWebSSO },
  settingsReducer: { message },
  stockReducer: { selectPlantId },
  surveyReducer: { surveyData },
  modalReducer: {
    modalMessage: {
      isEditing
    }
  },
  userReducer: {
    fullname,
    corporate,
    messageIconCount,
    infoMessing,
    userInfo,
    userInfoStatus,
    isConsentVisible
  },
  shippingType,
  getUrlWebSSOLogout,
  getUserManual,
  logout,
  messageList,
  surveyList,
  modalMessageOpen,
  modalSurveyOpen,
  modalQRLinkOpen,
  onMenuToggle,
  userCorporate,
  userGetInfo,
  userSetTheme,
  userMessageInfoVisibleClose,
  userMessageInfoVisibleOpen,
  userLogoutRequest,
  videoViewerByStockOpen,
  userConsentNeed,
  userConsentSave
}) => {
  const history = useHistory();
  // const [userName] = useState(fullname);
  const [themeBlack, setThemeBlack] = useState(window.localStorage.getItem('theme') === 'material.blue.light');
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);

  const [versionInfo, setVersionInfo] = useState(0);
  const [localization, setLocalization] = useState(
    localizations.filter((item) => item === getLocale())[0]
  );
  const [endSessionVisible, setEndSessionVisible] = useState(false);

  useEffect(() => {
    setVersionInfo(messageIconCount);
  }, [messageIconCount]);

  const userNews = useCallback((showAllMessages) => {
    modalMessageOpen({ modalShippingType: shippingType, showAllMessages });
  }, [modalMessageOpen, shippingType]);

  const openAllNews = useCallback(() => {
    userNews(true);
  }, [userNews]);

  const survey = useCallback(() => {
    modalSurveyOpen();
  }, [modalSurveyOpen]);

  useEffect(() => {
    const conditionValues = { userInfo, selectPlantId, shippingType };
    const checkConditionValues = Object.values(conditionValues).every(
      (el) => el !== null && el !== undefined
    );

    if (checkConditionValues) {
      messageList({ messageShippingType: shippingType, showAll: false });
    }
  }, [userInfo, selectPlantId, shippingType, messageList]);

  useEffect(() => {
    if (userInfo && selectPlantId) {
      surveyList();
    }
  }, [userInfo, selectPlantId, surveyList]);

  useEffect(() => {
    const surveyDate = window.localStorage.getItem('survey_date') || null;
    if (surveyData.length) {
      // const lastItem = surveyData[surveyData.length - 1];
      if (surveyDate === null || compare(surveyDate, dayjs()) < 0) {
        // && includeInPeriod(dayjs(lastItem.dateFrom).format('YYYY-MM-DD'),
        //   dayjs(lastItem.dateTo).format('YYYY-MM-DD'),
        //   dayjs().format('YYYY-MM-DD'))
        // && lastItem.isActiveFlag) {
        survey();
      }
    }
  }, [surveyData, survey]);

  useEffect(() => {
    if (themeBlack) {
      window.localStorage.setItem('theme', 'material.blue.light');
      userSetTheme('material.blue.light');
      document.body.className = 'material-blue-light';
    } else {
      window.localStorage.setItem('theme', 'material.blue.dark');
      userSetTheme('material.blue.dark');
      document.body.className = 'material-blue-dark';
    }
    setLoadPanelVisible(true);
    themes.ready(() => setLoadPanelVisible(false));
    themes.current(window.localStorage.theme);
  }, [themeBlack, userSetTheme]);

  useEffect(() => {
    if (logout) {
      window.localStorage.removeItem('userInfo');
      // document.execCommand('ClearAuthenticationCache'); // ie 11
      // history.push('/');
      // document.cookie = '';
      document.location.href = '/';
    }
  }, [logout, history]);

  useEffect(() => {
    userGetInfo();
    userCorporate();
    getUrlWebSSOLogout();
  }, [
    getUrlWebSSOLogout,
    userCorporate,
    userGetInfo
  ]);

  useEffect(() => {
    if (userInfo) {
      userConsentNeed();
    }
  }, [userInfo, userConsentNeed]);

  const ItemButtonMenu = useCallback(() => (
    <>
      <div className={style.divRow}>
        {/* // Кнопка в шапке страницы */}
        <Button elementAttr={{ class: style.butMenu }}
                type="normal"
                stylingMode="text"
                icon="/images/icon_menu.svg"
                onClick={onMenuToggle} />
        <img className={style.imgLogo} src={themeDark()
          ? `/images/${getLocale()}/severstal_logo_dark.png`
          : `/images/${getLocale()}/severstal_logo.png`} alt={formatMessage('severstalInfocom')} />
        <span className={style.textHeader}>{formatMessage('textTitleAuth')}</span>
      </div>
    </>
  ), [onMenuToggle]);

  const userManualRequest = useCallback(() => {
    getUserManual({ shippingType });
  }, [getUserManual, shippingType]);

  const onInitialized = useCallback((e) => {
    // eslint-disable-next-line no-underscore-dangle
    e.component._$popupContent[0].classList.add('drop-down-button__not_padding');
  }, []);

  const onValueChangedLocalization = useCallback(({ value }) => {
    setLocalization(localizations.filter((item) => item === value)[0]);
    locale(value);
    localStorage.setItem('locale', value);
    document.location.reload();
  }, []);

  /** Открытие модального окна с QR для мобильной версии */
  const downloadMobile = useCallback(() => {
    modalQRLinkOpen();
  }, [modalQRLinkOpen]);

  const onLogout = useCallback(() => {
    window.localStorage.removeItem('userInfo');
    window.localStorage.removeItem('redirectTime');
    userLogoutRequest();
    setTimeout(() => {
      document.location.href = `${document.location.origin}`;
    }, 1000);
  }, [userLogoutRequest]);

  // eslint-disable-next-line max-len
  /** Если сессия пользователя закончилась, то окно с предупреждением и редирект на стартовую страницу */
  useEffect(() => {
    if (userInfo !== false
      && !endSessionVisible
      && userInfoStatus === 500) {
      window.localStorage.setItem('redirectTime', dayjs(new Date().toLocaleString('en-US')).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'));
      setEndSessionVisible(true);
    }
  }, [endSessionVisible, userInfoStatus, userInfo]);
  //
  // const onHiding = useCallback(() => {
  //   setEndSessionVisible(false);
  // }, []);

  const openVideoViewer = useCallback(() => {
    if (selectPlantId && selectPlantId !== '-1') {
      videoViewerByStockOpen({ plantId: selectPlantId });
    }
  }, [videoViewerByStockOpen, selectPlantId]);

  const ItemUser = useCallback(() => (
    <>
      <Button visible={!!infoMessing.text}
              type="default"
              stylingMode="text"
              icon="info"
              elementAttr={{ class: style.infoMessing }}
              onClick={userMessageInfoVisibleOpen}
      />
      <div className={style.divRow}>
        { versionInfo > 0 && (
          <div className={style.versionInfo}>
            <span />
          </div>
        )}
        <DropDownButton stylingMode="text"
                        text={fullname}
                        dropDownOptions={{ onInitialized }}
                        icon={themeDark() ? '/images/defolt-user-dark.svg' : '/images/defolt-user.svg'}
        >
          <ItemDrop>
            <div title={formatMessage('downloadMobileVersion')} className={style.userDropItem}>
              <Button text={formatMessage('downloadMobileVersion')}
                     type={'default'}
                     stylingMode={'text'}
                     onClick={downloadMobile}
             />
            </div>
          </ItemDrop>
          <ItemDrop>
            <div title={formatMessage('news')} className={`${style.userDropItem}  ${style.newInfo}`}>
              <Button text={formatMessage('news')}
                      type={'default'}
                      stylingMode={'text'}
                      onClick={openAllNews}
              />
              <span style={{ display: !messageIconCount && 'none' }}>
                {messageIconCount}
              </span>
            </div>
          </ItemDrop>
          <ItemDrop shippingType={shippingType}>
            <div title={formatMessage('userManual')} className={style.userDropItem}>
              <Button text={formatMessage('userManual')}
                      type={'default'}
                      stylingMode={'text'}
                      onClick={userManualRequest}
              />
            </div>
          </ItemDrop>
          <ItemDrop>
            <div title={formatMessage('textLocal')} className={style.userDropItem}>
              <div>
                <span className={style.userDropItemFull}>{formatMessage('textLocal')}</span>
                <SelectBox items={localizations}
                           elementAttr={{ class: style.userSelectBox }}
                           stylingMode="filled"
                           value={localization}
                           onValueChanged={onValueChangedLocalization}
                />
              </div>
            </div>
          </ItemDrop>
          <ItemDrop>
            <div title={formatMessage('textThemes')} className={style.userDropItem}>
              <div>
                <span className={style.userDropItemFull}>{formatMessage('textThemes')}</span>
                <Switch value={!themeBlack} onValueChanged={() => setThemeBlack(!themeBlack)} />
              </div>
            </div>
          </ItemDrop>
          <ItemDrop>
            <form method="GET"
                  action={corporate ? '/api/logout/' : `/api${urlWebSSO.logout}`}
            >
              <div title={formatMessage('exit')} className={style.userDropItem}>
                <Button text={formatMessage('exit')}
                        type={'default'}
                        stylingMode={'text'}
                        onClick={onLogout}
                        useSubmitBehavior
                />
              </div>
            </form>
          </ItemDrop>
        </DropDownButton>
        <Button type="default"
                stylingMode="text"
                icon={themeDark() ? '/images/question_dark.svg' : '/images/question.svg'}
                onClick={() => openVideoViewer()}
                visible={!!selectPlantId}
        />
      </div>
    </>
  ), [
    infoMessing.text,
    userMessageInfoVisibleOpen,
    versionInfo,
    fullname,
    onInitialized,
    downloadMobile,
    messageIconCount,
    shippingType,
    userManualRequest,
    localization,
    onValueChangedLocalization,
    themeBlack,
    corporate,
    urlWebSSO.logout,
    onLogout,
    openVideoViewer,
    selectPlantId,
    openAllNews
  ]);

  const [consentAccepted, setConsentAccepted] = useState(false);
  const [consentAcceptable, setConsentAcceptable] = useState(false);

  const handleConsentSave = useCallback(() => {
    userConsentSave();
  }, [userConsentSave]);

  const handleReachBottom = useCallback((e) => {
    const scrollHeight = e.component.scrollHeight();
    const scrollTop = e.component.scrollTop();
    const clientHeight = e.component.clientHeight();
    const isReachedBottom = scrollHeight - scrollTop - clientHeight <= 5;
    if (isReachedBottom && !consentAcceptable) {
      setConsentAcceptable(true);
    }
  }, [consentAcceptable]);

  const ConsentModal = useMemo(() => (
    <Popup visible={isConsentVisible}
           title={formatMessage('textConsent').title}
           toolbarItems={[
             {
               widget: 'dxButton',
               location: 'after',
               options: {
                 icon: 'close',
                 onClick: (e) => {
                   const url = corporate ? '/api/logout/' : `/api${urlWebSSO.logout}`;
                   fetch(url).then(() => onLogout());
                 }
               }
             }
           ]}
           closeOnOutsideClick={false}
           showCloseButton={false}
           position={{ my: 'center', at: 'center', of: window }}
           width={'100%' && '680'}
           height="70%"
           className={style.consentPopup}
    >
      <ScrollView
        className={style.consentText}
        direction="vertical"
        height="100%"
        onScroll={handleReachBottom}
      >
        <p>{formatMessage('textConsent').p1}</p>
        <p>{formatMessage('textConsent').p2}</p>
        <p>{formatMessage('textConsent').p3}</p>
        <p>{formatMessage('textConsent').p4}</p>
        <p>{formatMessage('textConsent').p5}</p>
        <a href="https://suppliers.severstal.com/filelibrary/politika-v-oblasti-organizatsii-obrabotki-i-zashchity-personalnykh-dannykh/"
           target="_blank"
           rel="noopener noreferrer"
        >
          {formatMessage('textConsent').p6}
        </a>
      </ScrollView>

      <div className={style.consentForm}>
        <CheckBox
          value={consentAccepted}
          onValueChanged={({ value }) => setConsentAccepted(value)}
          text={formatMessage('textConsent').accept}
          disabled={!consentAcceptable}
        />
        <Button type="default" disabled={!consentAccepted} onClick={handleConsentSave}>Принять</Button>
      </div>
    </Popup>
  ), [
    isConsentVisible,
    consentAccepted,
    handleConsentSave,
    corporate,
    onLogout,
    urlWebSSO.logout,
    consentAcceptable,
    handleReachBottom
  ]);

  return (
    <>
      <Toolbar elementAttr={{ class: style.containing }}>
        <Item location={'before'} render={ItemButtonMenu} />
        <Item location={'after'} render={ItemUser} />
      </Toolbar>
      <Template name={'itemTheme'} render={() => (
        <div>
          <span>Темная тема</span>
          <Switch />
        </div>
      )} />
      <Template name={'itemLogout'} render={() => <div>Выход</div>} />
      <LoadPanel shadingColor={'rgba(0,0,0,0.8)'}
                 position={{ of: '#root' }}
                 showIndicator
                 shading
                 showPane
                 closeOnOutsideClick={false}
                 visible={loadPanelVisible}
      />
      <PopupErrorMVP visible={infoMessing.visible}
                     types="error"
                     width="600"
                     message={infoMessing.text}
                     techInfo={''}
                     onHiding={userMessageInfoVisibleClose}
                     title="ВНИМАНИЕ"
                     shading={false}
                     position="top"
      />
      {/* <PopupMVP visible={endSessionVisible} */}
      {/*           onHiding={onHiding} */}
      {/*           title={getLocale() === 'ru' ? 'ВНИМАНИЕ' : 'ATTENTION'} */}
      {/* > */}
      {/*   <div className="formData"> */}
      {/*     <p>{formatMessage('textError').endSession}</p> */}
      {/*     <div className="formButton"> */}
      {/*       <Button type="default" */}
      {/*               stylingMode="contained" */}
      {/*               width={200} */}
      {/*               onClick={onLogout()} */}
      {/*       > */}
      {/*         <span>{formatMessage('textButton').yes}</span> */}
      {/*       </Button> */}
      {/*     </div> */}
      {/*   </div> */}
      {/* </PopupMVP> */}
      {ConsentModal}
      <PopupErrorMVP visible={endSessionVisible}
                     types="error"
                     width="600"
                     message={formatMessage('textError').endSession}
                     techInfo={''}
                     onHiding={(() => (onLogout()))}
                     title={getLocale() === 'ru' ? 'ВНИМАНИЕ' : 'ATTENTION'}
                     shading={false}
                     position="top"
      />
    </>
  );
};

export default React.memo(Header);
